// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"video-player-module--player-wrapper--1UMAB","videoPlayer":"video-player-module--video-player--1pwPT"};